import { Cache } from "memory-cache";
import { CorporationOrderEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationOrderEntity(order_id: number): Promise<CorporationOrderEntity | null> {
  let entity: any = await cache.get(order_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationOrderEntity(order: CorporationOrderEntity) {
  cache.put(order.props.order_id.toString(), order, 60 * 60 * 1000 /* 1 hour */);
}
